import type { BFFArticleBodyElement } from "@src/app/types/bff";
import cx from "classnames";

export default function ArticleTable({
  element,
}: {
  element: BFFArticleBodyElement["table"];
}) {
  return (
    <table className="mb-4 table w-full table-fixed">
      <tbody>
        {(element.value || []).map((rows, i) => {
          return (
            <tr key={i} className={cx({ "bg-tertiary": i % 2 === 0 })}>
              {rows.map((cell, j) => {
                return (
                  <td className="h-8 border p-1" key={`${i}-${j}`}>
                    {cell}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
